import React, { useState, useEffect } from "react";
import Searchbar from "../Components/StatsComponent/Searchbar";
import Table from "../Components/StatsComponent/Statstable";
// import Table from "../Components/StatsComponent/Statstable";
import Totalorder from "../Components/StatsComponent/Totalorder";
import { Button } from "@material-ui/core";
import "./Stats.css";
import axios from "axios";
import ExportData from "../Components/StatsComponent/ExportData";
// import ExportData from "../Components/StatsComponent/ExportData";
import { Height } from "@material-ui/icons";
import _ from 'lodash'
//NOTE:- this stats component , calculate all the information like Aiorder, NonAiOrder, tolal call etc.
//This component has components Searchbar,TotalOrder,Table, Export Data
const Stats = () => {
  const [searchData, setSearchData] = useState({});

  // console.log("searchData", _.isEmpty(searchData))
  

  const [totalCallreceived, setTotalCallreceived] = useState(null);
  const [centerList, setCenterList] = useState([]);
  const [callDataTable, setCallDataTable] = useState([]);
  const [selectedCenterList, setSelectedCenterList] = useState([]);
  const [tableData, setTableData] = useState([])

  const [isFetchButtonClicked, setIsFetchButtonClicked] = useState(false)

  // console.log("totalCallreceived----", totalCallreceived);
  return (
    <div
      className="status"
      style={{
        display: "flex",
        flexDirection: "column",
        background: "#F1F1F1",
      }}
    >
      {/* Here we are calling Searchbar component and passing the method setSearchData,setCenterList, setSelectedCenterList */}
      <div className="status_filterBar">
        <Searchbar
          setSearchData={(val) => setSearchData(val)}
          setCenterList={(val) => setCenterList(val)}
          setSelectedCenterList={(val) => setSelectedCenterList(val)}
          setIsFetchButtonClicked={(val)=>setIsFetchButtonClicked(val)}
          setTableData={(val)=>setTableData(val)}
          isFetchButtonClicked={isFetchButtonClicked}
        />
      </div>

      <div
        className="stats__container"
        style={{ background: "white", border: "1px solid lightgray" }}
      >
        <div className="stats__orderDetails">
          {searchData && !_.isEmpty(searchData) && (
            <Totalorder
              searchData={searchData}
              setTotalCallreceived={(val) => setTotalCallreceived(val)}
              isFetchButtonClicked={isFetchButtonClicked}
            />
          )}
        </div>
        <div
          className="stats__siteTable"
          style={{
            paddingLeft: "100px",
            height: "300px",
            // overflowY: "scroll",
          }}
        >
          {searchData && !_.isEmpty(searchData) && (
            <>
              <div
                style={{
                  color: "black",
                  fontSize: "17px",
                  marginBottom: "15px",
                }}
              >
                Site Details
              </div>
              <div>
                {Array.isArray(tableData)  && 
                  <Table
                    selectedCenterList={selectedCenterList}
                    tableData={tableData}
                    centerList={centerList}
                    setCallDataTable={(val) => setCallDataTable(val)}
                  />
                }
              </div>
            </>
          )}
        </div>
        <div className="stats__exportButton">
          {searchData && !_.isEmpty(searchData) && (
            <ExportData callDataTable={callDataTable} searchData={searchData.calls_details} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Stats;
